import { render, staticRenderFns } from "./sucaiDataListById.vue?vue&type=template&id=c4c1fc9c&scoped=true&"
import script from "./sucaiDataListById.vue?vue&type=script&lang=js&"
export * from "./sucaiDataListById.vue?vue&type=script&lang=js&"
import style0 from "./sucaiDataListById.vue?vue&type=style&index=0&id=c4c1fc9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c1fc9c",
  null
  
)

export default component.exports